import { NurseryTruckParameter } from '@general/nursery-truck-parameter/nursery-truck-parameter';
import { VehicleService } from '@general/proxy/general/controllers';
import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MenuCategories, MenuSubcategories, MENU_SUBCATEGORY_KEY } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const TRUCK_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('engagedWithId', 'Entity.EngagedWith', VehicleService)
    .displayFromNested('engagedWith.name')
    .sortBy('engagedWith.name')
    .build(),
  FieldBuilder
    .foreignKey('vehicleId', 'Entity.Vehicle', VehicleService)
    .required()
    .displayFromNested('vehicle.name')
    .sortBy('vehicle.name') 
    .hideInChildForms()
    .build(),
];

export const TRUCK_CONFIG = {
  entityName: 'Truck',
  localizationKey: 'General::Entity.Truck',
  fields: TRUCK_FIELDS,
  permission: 'GeneralMachinesAndVehicles.Trucks',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
  children: [
      {
        entityName: 'NurseryTruckParameter',
        foreignKeyField: 'truckId',
        localizationKey: 'General::Entity.NurseryTruckParameter',
        component: NurseryTruckParameter,
      },
  ]
};
